/**
 * Referral link (`/r/:code`, §12.1 / §12.4): resolves the code, then lands on the lottery with the campaign
 * tags the API published so `captureArrival` records the source. The code itself travels as `?ref=`.
 */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const ReferralPage = lazyRoute(() => import('./ReferralPage'));

export const referralRoutes: RouteObject[] = [{ path: '/r/:code', element: <ReferralPage /> }];
